import type {HTMLChakraProps} from '@linx-security/ui';
import {Box} from '@linx-security/ui';
import type {ImageProps, StaticImageData} from 'next/image';
import Image from 'next/image';

type Props = Omit<ImageProps, 'src' | 'priority' | 'loading'> & {
  srcLight: StaticImageData;
  srcDark: StaticImageData;
  blurWidth?: number;
  blurHeight?: number;
} & Pick<HTMLChakraProps<'div'>, 'flexBasis'>;

/**
 * ThemeImage component renders an image according to the current color mode.
 */
export const ThemeImage = (props: Props) => {
  const {srcLight, srcDark, flexBasis, ...rest} = props;

  // Filter out props that shouldn't be passed to DOM elements
  const {blurWidth: _blurWidth, blurHeight: _blurHeight, ...validImageProps} = rest;

  // Filter out blur properties from static image data
  const {blurWidth: _lightBlurWidth, blurHeight: _lightBlurHeight, ...cleanSrcLight} = srcLight;
  const {blurWidth: _darkBlurWidth, blurHeight: _darkBlurHeight, ...cleanSrcDark} = srcDark;

  return (
    <Box
      sx={{
        flexBasis,
        '.img-dark': {
          display: `none`,
        },
        _dark: {
          '.img-light': {
            display: `none`,
          },
          '.img-dark': {
            display: `unset`,
          },
        },
      }}>
      <Image {...cleanSrcLight} {...validImageProps} className={`img-light`} />
      <Image {...cleanSrcDark} {...validImageProps} className={`img-dark`} />
    </Box>
  );
};
